import React, { useState } from 'react'
import { MapRef } from 'react-map-gl'
import {
  Center,
  City,
  defaultCoordinates,
  SetState,
  ViewState,
} from '../../../types/AddressesGroup'
import Map from './Map'
import Pagination from './Pagination'

interface AddressesGroupListProps {
  centers: Center[]
  isCorporation: boolean
  isTopCfe: boolean
  viewState: ViewState
  setViewState: SetState<ViewState>
  setSelectedCity: SetState<City | undefined>
  mapRef: MapRef | null
  setCurrentPage: SetState<number>
  currentPage: number
  selectedCity: City | undefined
  waitForMvt: boolean
  setWaitForMvt: SetState<boolean>
  MAPBOX_API_KEY: string
  MAPBOX_API_STYLE: string
  isBe: boolean
  defaultCoordinates: defaultCoordinates
  hostname: string
  isTouch: boolean
}
const AddressesGroupsList: React.FC<AddressesGroupListProps> = ({
  isCorporation,
  centers,
  isTopCfe,
  viewState,
  setViewState,
  setSelectedCity,
  mapRef,
  setCurrentPage,
  currentPage,
  selectedCity,
  waitForMvt,
  setWaitForMvt,
  MAPBOX_API_KEY,
  MAPBOX_API_STYLE,
  isBe,
  defaultCoordinates,
  hostname,
  isTouch,
}: AddressesGroupListProps) => {
  const [centersInList, setCentersInList] = useState<Center[] | []>(centers)
  return (
    <div className="section py-0">
      <div className="container">
        <div className="columns">
          <div className="column pr-3 is-7 is-full-touch">
            <Pagination
              itemsPerPage={10}
              centersInList={isTouch ? centers : centersInList}
              isCorporation={isCorporation}
              isTopCfe={isTopCfe}
              setSelectedCity={setSelectedCity}
              centers={centers}
              mapRef={mapRef}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              selectedCity={selectedCity}
              defaultCoordinates={defaultCoordinates}
              isBe={isBe}
              hostname={hostname}
            />
          </div>
          {!isTouch && (
            <div className="column addresses-map p-0">
              <Map
                setCentersInList={setCentersInList}
                centers={centers}
                viewState={viewState}
                setViewState={setViewState}
                isCorporation={isCorporation}
                isTopCfe={isTopCfe}
                mapRef={mapRef}
                setSelectedCity={setSelectedCity}
                waitForMvt={waitForMvt}
                setWaitForMvt={setWaitForMvt}
                MAPBOX_API_KEY={MAPBOX_API_KEY}
                MAPBOX_API_STYLE={MAPBOX_API_STYLE}
                isTouch={isTouch}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AddressesGroupsList
